import React, { FC } from 'react'

import { Photo, Photos } from 'components/page/ForeignProfile/common.types'
import { MobilePhotosView } from 'components/page/ForeignProfile/Photos/MobilePhotos/MobilePhotosView'
import { useForeignPhotoContext } from 'components/page/ForeignProfile/Photos/Photos.hooks'

import { ForeignPhotoContext } from '../../ForeignProfile.constants'

export const MobilePhotosIndex: FC<{
  hasIncognito: boolean
  photos?: Photos
  photo?: Photo
}> = ({ hasIncognito, photos, photo }) => {
  const value = useForeignPhotoContext(hasIncognito)

  return (
    <ForeignPhotoContext.Provider value={value}>
      <MobilePhotosView photos={photos} photo={photo} />
    </ForeignPhotoContext.Provider>
  )
}
